var _defs, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250,
    zoomAndPan: "magnify",
    viewBox: "0 0 187.5 187.499992",
    height: 250,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "53cd9e28f8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 43 1 L 112 1 L 112 22 L 43 22 Z M 43 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2605e2f176"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -8.261719 108.242188 L 60.363281 -8.882812 L 195.609375 70.355469 L 126.984375 187.484375 Z M -8.261719 108.242188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "066f51d91e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -8.261719 108.242188 L 60.363281 -8.882812 L 195.609375 70.355469 L 126.984375 187.484375 Z M -8.261719 108.242188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4320bee35c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 59 10 L 95 10 L 95 129 L 59 129 Z M 59 10 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "675eb0f6f2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -8.261719 108.242188 L 60.363281 -8.882812 L 195.609375 70.355469 L 126.984375 187.484375 Z M -8.261719 108.242188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d8beb7d210"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -8.261719 108.242188 L 60.363281 -8.882812 L 195.609375 70.355469 L 126.984375 187.484375 Z M -8.261719 108.242188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aedfba0e08"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 59 69 L 94 69 L 94 129 L 59 129 Z M 59 69 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a44b7c02c5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -8.261719 108.242188 L 60.363281 -8.882812 L 195.609375 70.355469 L 126.984375 187.484375 Z M -8.261719 108.242188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a4ebf4aa76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -8.261719 108.242188 L 60.363281 -8.882812 L 195.609375 70.355469 L 126.984375 187.484375 Z M -8.261719 108.242188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ffca78d160"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 93 69 L 128 69 L 128 187 L 93 187 Z M 93 69 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a62e2ffdff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -8.261719 108.242188 L 60.363281 -8.882812 L 195.609375 70.355469 L 126.984375 187.484375 Z M -8.261719 108.242188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "809cb92c0f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -8.261719 108.242188 L 60.363281 -8.882812 L 195.609375 70.355469 L 126.984375 187.484375 Z M -8.261719 108.242188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5c8d71256d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 93 69 L 128 69 L 128 129 L 93 129 Z M 93 69 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dc951bb937"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -8.261719 108.242188 L 60.363281 -8.882812 L 195.609375 70.355469 L 126.984375 187.484375 Z M -8.261719 108.242188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "66a69a708d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -8.261719 108.242188 L 60.363281 -8.882812 L 195.609375 70.355469 L 126.984375 187.484375 Z M -8.261719 108.242188 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#53cd9e28f8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2605e2f176)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#066f51d91e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#31bdb7",
    d: "M 111.054688 20.925781 L 77.242188 1.117188 L 43.207031 20.445312 L 111.582031 21.234375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4320bee35c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#675eb0f6f2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d8beb7d210)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#31bdb7",
    d: "M 94.148438 11.019531 L 60.226562 10.78125 L 59.671875 108.628906 L 93.484375 128.433594 Z M 94.148438 11.019531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aedfba0e08)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a44b7c02c5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a4ebf4aa76)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d7270",
    d: "M 59.671875 108.628906 L 93.484375 128.433594 L 93.816406 69.730469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ffca78d160)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a62e2ffdff)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#809cb92c0f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1b5f5d",
    d: "M 127.628906 89.539062 L 93.816406 69.730469 L 93.261719 167.578125 L 127.074219 187.382812 Z M 127.628906 89.539062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5c8d71256d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dc951bb937)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#66a69a708d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#193b38",
    d: "M 127.628906 89.539062 L 93.816406 69.730469 L 93.484375 128.433594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbove);
export default __webpack_public_path__ + "static/media/above.d722cc596d987b0d1cb362b22b6e9535.svg";
export { ForwardRef as ReactComponent };